import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
    Card, Table, Button, Checkbox, TableRow, TableBody, TableCell, Container, TableContainer, TablePagination, Modal, Box,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import Iconify from "../../components/Iconify";
import { UserListHead } from "../../sections/@dashboard/user";
import HeaderBreadcrumbs from "../../components/HeaderBreadcrumbs";
import { GetActiveSeriesListAction, SeriesChangeStatusAction } from "../../redux/actions/SeriesAction";
import Loader from "src/components/Loader";
import moment from "moment";

export default function ActiveSeriesList() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const ContestListData = useSelector((state) => state.matches.active_series_list.data);
    const statusSelector = useSelector(state => state.series.series_action)
    const loadingSelector = useSelector(state => state.series.loading)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("name");
    const [publichClick, setPublichClick] = useState(false);
    const [state, setState] = useState({
        ContestListData: [],
        totalCountContestList: 0,
        logoImg: [],
        title: "",
        subtitle: "",
        dis_val: "",
    });

    useEffect(() => {
        if (ContestListData !== undefined) {
            setState({
                ...state,
                ContestListData: ContestListData.data.active_series_list,
                totalCountContestList: ContestListData.data.total_count,
            });
        }
    }, [ContestListData]);

    useEffect(() => {
        dispatch(GetActiveSeriesListAction(page, rowsPerPage, "ckt"));
    }, [page, rowsPerPage]);

    useEffect(() => {
        if (Object.keys(statusSelector).length > 0 && publichClick) {
            dispatch(GetActiveSeriesListAction(page, rowsPerPage, "ckt"))
            setPublichClick(false)
        }
    }, [statusSelector, page, rowsPerPage, publichClick])

    const handleRequestSort = (_, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    };

    const ViewPools = (contest_id, name,data) => {
        navigate(`/dashboard/activepoollistseries/${contest_id}`, { state: { name: name, type: "s", gtype: "ckt","data":data?.season } }, { replace: true });
    };

    return (
        <Page title="Active Series">
            {loadingSelector ? <Loader /> : null}
            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Active Series"
                    links={[
                        { name: "Dashboard", href: "/dashboard/app" },
                        { name: "Active Series" },
                    ]}
                />

                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    order={order}
                                    orderBy={orderBy}
                                    headLabel={[
                                        { id: "c_no", label: "Sr no.", alignRight: false },
                                        { id: 'Series Name', label: 'Series Name', alignRight: false },
                                        { id: 'category', label: 'category', alignRight: false },
                                        { id: 'match_format', label: 'match_format', alignRight: false },
                                        { id: "c_date", label: "Date", alignRight: false },
                                        { id: "c_pool", label: "Pool Contest", alignRight: false },
                                        { id: "c_publish", label: "Publish", alignRight: false }
                                    ]}
                                    rowCount={state.totalCountContestList}
                                    // onRequestSort={handleRequestSort}
                                />
                                <TableBody>
                                    {state.ContestListData.map((data, index) => {
                                        return (
                                            <TableRow key={index}>
                                                <TableCell component="th" scope="row"> {page * rowsPerPage + (index + 1)}. </TableCell>
                                                <TableCell component="th" scope="row"> {data.name}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textTransform: "capitalize" }}> {data.category}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textTransform: "capitalize" }}> {data.match_format}</TableCell>
                                                <TableCell component="th" scope="row"> 
                                                     {
                                                        data.date_start ?
                                                            `${moment(data.date_start).format("DD MMM")}  to  ${moment(data.date_end).format("DD MMM YYYY")}`
                                                            :
                                                            "-"
                                                    }
                                                    </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <Button onClick={() => ViewPools(data.cid, data.name,data
)}>
                                                        <Iconify icon="eva:eye-fill" width={24} height={24} />
                                                    </Button>
                                                </TableCell>
                                                <TableCell omponent="th" scope="row">
                                                    <Checkbox
                                                        checked={data.is_publish === 1 ? true : false}
                                                        onChange={({ target }) => {
                                                            {
                                                                dispatch(
                                                                    SeriesChangeStatusAction({
                                                                        cid: data.cid,
                                                                        is_publish: data.is_publish == 1 ? 0 : 1,
                                                                        type: "ckt"
                                                                    })
                                                                );
                                                                setPublichClick(true)
                                                            }
                                                        }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>

                    <TablePagination
                        rowsPerPageOptions={[25, 50, 100, 150, 200]}
                        component="div"
                        count={state.totalCountContestList}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </Container>
        </Page>
    );
}